import { useLangStore } from "@/store/lang.js";
import { useTenantContext } from "@/hooks/useTenantContext.js";
import type { Language } from "@templestay/i18n";

function resolve(map: Record<string, string> | undefined, lang: Language): string {
  if (!map) return "";
  return map[lang] || map.ko || "";
}

export function Footer() {
  const { lang } = useLangStore();
  const { tenantTheme } = useTenantContext();
  const f = tenantTheme?.footer;

  const name = resolve(f?.name, lang);
  const address = resolve(f?.address, lang);
  const phone = resolve(f?.phone, lang);
  const copyright = resolve(f?.copyright, lang) || `© Templestay`;

  if (!name && !address && !phone) {
    return (
      <footer className="py-10 text-center">
        <p className="text-[11px] text-gray-400/40">{copyright}</p>
      </footer>
    );
  }

  return (
    <footer className="py-10 text-center">
      {name && (
        <div className="flex items-center justify-center gap-2 mb-3">
          <img
            src="/api/branding/logo"
            alt=""
            className="h-5 w-5 object-contain opacity-25"
            draggable={false}
          />
          <span className="text-sm font-semibold text-gray-400/70">{name}</span>
        </div>
      )}
      <div className="space-y-1 text-xs text-gray-400/60 leading-relaxed">
        {address && <p>{address}</p>}
        {phone && <p>{phone}</p>}
      </div>
      <p className="mt-4 text-[11px] text-gray-400/40">{copyright}</p>
    </footer>
  );
}
